<template>
    <div style="display: flex; flex-direction: column; align-items: center">
        <div style="margin-bottom: 28px">
            <span style="font-size: 22px">立项信息</span>
        </div>
        <div v-if="type !== 'attachment'" class="jdt">
            <div class="jdt-main">
                <div
                    v-for="(item, index) in xmItem"
                    :key="item.index"
                    class="item"
                    :class="{
                        'item-top_item0ea04d': item.status == 1 || item.status == 2
                    }"
                >
                    <div
                        class="item-top"
                        :style="{
                            background: item.status == 0 ? '#DEE2E6' : item.status == 1 ? '#ABEDCB' : '#1070CB'
                        }"
                    >
                        {{ index + 1 }}
                    </div>
                    <span class="item-text">{{ item.name }}</span>
                </div>
            </div>
        </div>
        <el-form :model="vo" @submit.native.prevent>
            <div style="width: 100%" class="el-table el-table--fit el-table--border">
                <div class="el-table__body-wrapper">
                    <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                        <tbody>
                            <tr>
                                <td ref="tdlbl_造价项目名称" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'flSubject'" class="field">造价项目名称</span>
                                </td>
                                <td class="el-table__cell tdcont tdw83" colspan="5">
                                    <form-item
                                        ref="flSubject"
                                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入造价项目名称', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '造价项目名称', propName: 'flSubject', propType: 'String', textFormatter: 'textfield', valueMaxLength: null, valueMinLength: null, model: 'vo.flSubject', option: [], autocomplete: 'off', dialog: 0, showWordLimit: false }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_项目负责人" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'xmFzr'" class="field">项目负责人</span>
                                </td>
                                <td class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item ref="xmFzr" :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入项目负责人', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '项目负责人', propName: 'xmFzr', propType: 'String', textFormatter: 'textfield', valueMaxLength: null, valueMinLength: null, model: 'vo.xmFzr', option: [] }" :vo="vo" :can-edit="canEdit" />
                                </td>
                                <td ref="tdlbl_公司统一编号" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'projectCode'" class="field">公司统一编号</span>
                                </td>
                                <td class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item
                                        ref="projectCode"
                                        :field="{
                                            defaultValue: null,
                                            elementCanEdit: '{${canEdit}}',
                                            elementCssHeight: null,
                                            elementCssWidth: null,
                                            elementFormatter: null,
                                            elementReadonly: 0,
                                            elementType: 'input',
                                            emptyMessage: '请输入公司统一编号',
                                            errorMessage: null,
                                            formTdAlign: 'text-left',
                                            formTdColspan: 0,
                                            isRequired: 1,
                                            onClickEvent: null,
                                            passenger: {},
                                            propComment: '公司统一编号',
                                            propName: 'projectCode',
                                            propType: 'String',
                                            textFormatter: 'textfield',
                                            valueMaxLength: null,
                                            valueMinLength: null,
                                            model: 'vo.projectCode',
                                            option: [],
                                            autocomplete: 'off',
                                            dialog: 0,
                                            showWordLimit: false
                                        }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_项目性质" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'xmNature'" class="field">项目性质</span>
                                </td>
                                <td class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item
                                        ref="xmNature"
                                        :field="{
                                            defaultValue: null,
                                            elementCanEdit: '{${canEdit}}',
                                            elementCssHeight: null,
                                            elementCssWidth: null,
                                            elementFormatter: '1：新建项目\n2：扩建项目\n3：改建项目\n4：迁建项目\n5：恢复项目',
                                            elementReadonly: 1,
                                            elementType: 'select',
                                            emptyMessage: '请选择项目性质',
                                            errorMessage: null,
                                            formTdAlign: 'text-left',
                                            formTdColspan: 0,
                                            isRequired: 1,
                                            onClickEvent: null,
                                            passenger: {},
                                            propComment: '项目性质',
                                            propName: 'xmNature',
                                            propType: 'Short',
                                            textFormatter: null,
                                            valueMaxLength: null,
                                            valueMinLength: null,
                                            model: 'vo.xmNature',
                                            option: [
                                                { value: '1', name: '新建项目' },
                                                { value: '2', name: '扩建项目' },
                                                { value: '3', name: '改建项目' },
                                                { value: '4', name: '迁建项目' },
                                                { value: '5', name: '恢复项目' }
                                            ],
                                            optionGenerateType: 0,
                                            clearable: false,
                                            filterable: false,
                                            allowCreate: false
                                        }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                                <td ref="tdlbl_业务类型" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'xmBusiType'" class="field">业务类型</span>
                                </td>
                                <td class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item
                                        ref="xmBusiType"
                                        :field="{
                                            defaultValue: null,
                                            elementCanEdit: '{${canEdit}}',
                                            elementCssHeight: null,
                                            elementCssWidth: null,
                                            elementFormatter: '1：司法鉴定\n2：评估报告\n3：工程量验收报告\n4：概算\n5：预算\n6：预算评审报告\n7：结算\n8：结算审核报告\n9：工程量清单\n10：预算控制价审核\n11：全过程\n12：招标控制价',
                                            elementReadonly: 1,
                                            elementType: 'select',
                                            emptyMessage: '请选择业务类型',
                                            errorMessage: null,
                                            formTdAlign: 'text-left',
                                            formTdColspan: 0,
                                            isRequired: 1,
                                            onClickEvent: null,
                                            passenger: {},
                                            propComment: '业务类型',
                                            propName: 'xmBusiType',
                                            propType: 'Short',
                                            textFormatter: null,
                                            valueMaxLength: null,
                                            valueMinLength: null,
                                            model: 'vo.xmBusiType',
                                            option: [
                                                { value: '1', name: '司法鉴定' },
                                                { value: '2', name: '评估报告' },
                                                { value: '3', name: '工程量验收报告' },
                                                { value: '4', name: '概算' },
                                                { value: '5', name: '预算' },
                                                { value: '6', name: '预算评审报告' },
                                                { value: '7', name: '结算' },
                                                { value: '8', name: '结算审核报告' },
                                                { value: '9', name: '工程量清单' },
                                                { value: '10', name: '预算控制价审核' },
                                                { value: '11', name: '全过程' },
                                                { value: '12', name: '招标控制价' }
                                            ],
                                            optionGenerateType: 0,
                                            clearable: false,
                                            filterable: false,
                                            allowCreate: false
                                        }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_项目专业" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'xmMajor'" class="field">项目专业</span>
                                </td>
                                <td class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item
                                        ref="xmMajor"
                                        :field="{
                                            defaultValue: null,
                                            elementCanEdit: '{${canEdit}}',
                                            elementCssHeight: null,
                                            elementCssWidth: null,
                                            elementFormatter: '1：土建工程\n2：安装工程\n3：水利工程\n4：市政工程\n5：公路工程\n6：装饰装修\n7：钢结构',
                                            elementReadonly: 1,
                                            elementType: 'select',
                                            emptyMessage: '请选择项目专业',
                                            errorMessage: null,
                                            formTdAlign: 'text-left',
                                            formTdColspan: 0,
                                            isRequired: 1,
                                            onClickEvent: null,
                                            passenger: {},
                                            propComment: '项目专业',
                                            propName: 'xmMajor',
                                            propType: 'Short',
                                            textFormatter: null,
                                            valueMaxLength: null,
                                            valueMinLength: null,
                                            model: 'vo.xmMajor',
                                            option: [
                                                { value: '1', name: '土建工程' },
                                                { value: '2', name: '安装工程' },
                                                { value: '3', name: '水利工程' },
                                                { value: '4', name: '市政工程' },
                                                { value: '5', name: '公路工程' },
                                                { value: '6', name: '装饰装修' },
                                                { value: '7', name: '钢结构' }
                                            ],
                                            optionGenerateType: 0,
                                            clearable: false,
                                            filterable: false,
                                            allowCreate: false
                                        }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                                <td ref="tdlbl_资金来源" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'xmFund'" class="field">资金来源</span>
                                </td>
                                <td class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item
                                        ref="xmFund"
                                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入资金来源', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '资金来源', propName: 'xmFund', propType: 'String', textFormatter: 'textfield', valueMaxLength: null, valueMinLength: null, model: 'vo.xmFund', option: [], autocomplete: 'off', dialog: 0, showWordLimit: false }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_项目来源" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'xmFrom'" class="field">项目来源</span>
                                </td>
                                <td class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item
                                        ref="xmFrom"
                                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入项目来源', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '项目来源', propName: 'xmFrom', propType: 'String', textFormatter: 'textfield', valueMaxLength: null, valueMinLength: null, model: 'vo.xmFrom', option: [], autocomplete: 'off', dialog: 0, showWordLimit: false }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                                <td ref="tdlbl_项目接收日期 " class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'xmReceiveDate'" class="field">项目接收日期</span>
                                </td>
                                <td class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item
                                        ref="xmReceiveDate"
                                        :field="{
                                            defaultValue: null,
                                            elementCanEdit: '{${canEdit}}',
                                            elementCssHeight: null,
                                            elementCssWidth: null,
                                            elementFormatter: 'format：yyyy年MM月dd日\r\n',
                                            elementReadonly: 1,
                                            elementType: 'date',
                                            emptyMessage: '请输入项目接收日期 ',
                                            errorMessage: null,
                                            formTdAlign: 'text-left',
                                            formTdColspan: 0,
                                            isRequired: 1,
                                            onClickEvent: null,
                                            passenger: {},
                                            propComment: '项目接收日期 ',
                                            propName: 'xmReceiveDate',
                                            propType: 'java.util.Date',
                                            textFormatter: 'yyyy年MM月dd日\r\n',
                                            valueMaxLength: null,
                                            valueMinLength: null,
                                            model: 'vo.xmReceiveDate',
                                            option: [],
                                            weekday: 0
                                        }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_项目状态" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'xmStatus'" class="field">项目状态</span>
                                </td>
                                <td class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item
                                        ref="xmStatus"
                                        :field="{
                                            defaultValue: null,
                                            elementCanEdit: '{${canEdit}}',
                                            elementCssHeight: null,
                                            elementCssWidth: null,
                                            elementFormatter: '0：未开始\n1：进行中\n2：已结束',
                                            elementReadonly: 1,
                                            elementType: 'select',
                                            emptyMessage: '请选择项目状态',
                                            errorMessage: null,
                                            formTdAlign: 'text-left',
                                            formTdColspan: 0,
                                            isRequired: 1,
                                            onClickEvent: null,
                                            passenger: {},
                                            propComment: '项目状态',
                                            propName: 'xmStatus',
                                            propType: 'Short',
                                            textFormatter: null,
                                            valueMaxLength: null,
                                            valueMinLength: null,
                                            model: 'vo.xmStatus',
                                            option: [
                                                { value: '0', name: '未开始' },
                                                { value: '1', name: '进行中' },
                                                { value: '2', name: '已结束' }
                                            ],
                                            optionGenerateType: 0,
                                            clearable: false,
                                            filterable: false,
                                            allowCreate: false
                                        }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                                <td ref="tdlbl_项目规模" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'xmScale'" class="field">项目规模</span>
                                </td>
                                <td class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item
                                        ref="xmScale"
                                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入项目规模', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '项目规模', propName: 'xmScale', propType: 'String', textFormatter: 'textfield', valueMaxLength: null, valueMinLength: null, model: 'vo.xmScale', option: [], autocomplete: 'off', dialog: 0, showWordLimit: false }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_中标通知书日期" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span v-field-lbl="'noticeDate'" class="field">中标通知书日期</span>
                                </td>
                                <td class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item
                                        ref="noticeDate"
                                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 1, elementType: 'date', emptyMessage: '请输入中标通知书日期', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '中标通知书日期', propName: 'noticeDate', propType: 'java.util.Date', textFormatter: 'yyyy年MM月dd日', valueMaxLength: null, valueMinLength: null, model: 'vo.noticeDate', option: [], weekday: 0 }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                                <td ref="tdlbl_中标通知书负责人" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span v-field-lbl="'noticePerson'" class="field">中标通知书负责人</span>
                                </td>
                                <td class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item
                                        ref="noticePerson"
                                        :field="{
                                            defaultValue: null,
                                            elementCanEdit: '{${canEdit}}',
                                            elementCssHeight: null,
                                            elementCssWidth: null,
                                            elementFormatter: null,
                                            elementReadonly: 0,
                                            elementType: 'input',
                                            emptyMessage: '请输入中标通知书负责人',
                                            errorMessage: null,
                                            formTdAlign: 'text-left',
                                            formTdColspan: 0,
                                            isRequired: 0,
                                            onClickEvent: null,
                                            passenger: {},
                                            propComment: '中标通知书负责人',
                                            propName: 'noticePerson',
                                            propType: 'String',
                                            textFormatter: 'textfield',
                                            valueMaxLength: null,
                                            valueMinLength: null,
                                            model: 'vo.noticePerson',
                                            option: [],
                                            autocomplete: 'off',
                                            dialog: 1,
                                            showWordLimit: false,
                                            dialogType: 'staff',
                                            dialogOrgLevel: '',
                                            dialogSelectedOrderBy: 'orgOrderNo',
                                            dialogMultiple: false,
                                            dialogOrgSelf: false,
                                            dialogOnlyCurSys: true,
                                            valueIdsField: 'vo.noticePersonId'
                                        }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_建设单位" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'jsUnit'" class="field">建设单位</span>
                                </td>
                                <td class="el-table__cell tdcont tdw83" colspan="5">
                                    <form-item
                                        ref="jsUnit"
                                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入建设单位', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '建设单位', propName: 'jsUnit', propType: 'String', textFormatter: 'textfield', valueMaxLength: null, valueMinLength: null, model: 'vo.jsUnit', option: [], autocomplete: 'off', dialog: 0, showWordLimit: false }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_施工单位" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span v-field-lbl="'sgUnit'" class="field">施工单位</span>
                                </td>
                                <td class="el-table__cell tdcont tdw83" colspan="5">
                                    <form-item
                                        ref="sgUnit"
                                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入施工单位', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '施工单位', propName: 'sgUnit', propType: 'String', textFormatter: 'textfield', valueMaxLength: null, valueMinLength: null, model: 'vo.sgUnit', option: [], autocomplete: 'off', dialog: 0, showWordLimit: false }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_设计单位" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span v-field-lbl="'sjUnit'" class="field">设计单位</span>
                                </td>
                                <td class="el-table__cell tdcont tdw83" colspan="5">
                                    <form-item
                                        ref="sjUnit"
                                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入设计单位', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '设计单位', propName: 'sjUnit', propType: 'String', textFormatter: 'textfield', valueMaxLength: null, valueMinLength: null, model: 'vo.sjUnit', option: [], autocomplete: 'off', dialog: 0, showWordLimit: false }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_监理单位" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span v-field-lbl="'jlUnit'" class="field">监理单位</span>
                                </td>
                                <td class="el-table__cell tdcont tdw83" colspan="5">
                                    <form-item
                                        ref="jlUnit"
                                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入监理单位', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '监理单位', propName: 'jlUnit', propType: 'String', textFormatter: 'textfield', valueMaxLength: 200, valueMinLength: null, model: 'vo.jlUnit', option: [], autocomplete: 'off', dialog: 0, showWordLimit: false }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td class="tdlbl tdw100" colspan="6" style="text-align: left !important; background: #fff !important">
                                    <div>委托单位信息</div>
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_委托单位名称" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'wtUnit'" class="field">委托单位名称</span>
                                </td>
                                <td class="el-table__cell tdcont tdw83" colspan="5">
                                    <form-item
                                        ref="wtUnit"
                                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入委托单位名称', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '委托单位名称', propName: 'wtUnit', propType: 'String', textFormatter: 'textfield', valueMaxLength: null, valueMinLength: null, model: 'vo.wtUnit', option: [], autocomplete: 'off', dialog: 0, showWordLimit: false }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_单位负责人" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'wtUnitFzr'" class="field">单位负责人</span>
                                </td>
                                <td class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item
                                        ref="wtUnitFzr"
                                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入单位负责人', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '单位负责人', propName: 'wtUnitFzr', propType: 'String', textFormatter: 'textfield', valueMaxLength: null, valueMinLength: null, model: 'vo.wtUnitFzr', option: [], autocomplete: 'off', dialog: 0, showWordLimit: false }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                                <td ref="tdlbl_单位负责人电话" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'wtUnitFzrPhone'" class="field">单位负责人电话</span>
                                </td>
                                <td class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item
                                        ref="wtUnitFzrPhone"
                                        :field="{
                                            defaultValue: null,
                                            elementCanEdit: '{${canEdit}}',
                                            elementCssHeight: null,
                                            elementCssWidth: null,
                                            elementFormatter: null,
                                            elementReadonly: 0,
                                            elementType: 'input',
                                            emptyMessage: '请输入单位负责人电话',
                                            errorMessage: null,
                                            formTdAlign: 'text-left',
                                            formTdColspan: 0,
                                            isRequired: 1,
                                            onClickEvent: null,
                                            passenger: {},
                                            propComment: '单位负责人电话',
                                            propName: 'wtUnitFzrPhone',
                                            propType: 'String',
                                            textFormatter: 'textfield',
                                            valueMaxLength: null,
                                            valueMinLength: null,
                                            model: 'vo.wtUnitFzrPhone',
                                            option: [],
                                            autocomplete: 'off',
                                            dialog: 0,
                                            showWordLimit: false
                                        }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_单位邮箱" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span v-field-lbl="'wtUnitAddress'" class="field">单位邮箱</span>
                                </td>
                                <td class="el-table__cell tdcont tdw83" colspan="5">
                                    <form-item
                                        ref="wtUnitAddress"
                                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入单位邮箱', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '单位邮箱', propName: 'wtUnitAddress', propType: 'String', textFormatter: 'textfield', valueMaxLength: null, valueMinLength: null, model: 'vo.wtUnitAddress', option: [], autocomplete: 'off', dialog: 0, showWordLimit: false }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td class="el-table__cell tdcont tdw83" colspan="6" style="padding: 0px !important; border-bottom: 0px !important">
                                    <jsmx v-if="showJsmx" ref="jggdmx" :vo="vo" :can-edit="canEdit" :module="'invoiceApplyProjectItem'" :base-url="'cwgl'" :is-http="false" :list-name="'projectItemList'"></jsmx>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </el-form>
    </div>
</template>

<script>
import jsmx from '@/wapp/zjgl/jsmx/jsmx'
export default {
    components: {
        jsmx
    },
    props: {
        vo: {
            type: Object,
            default: function () {
                return {}
            }
        },
        canEdit: { type: Number, default: 0 },
        module: { type: String, default: null }
    },
    data() {
        return {
            attachments: [],
            xmItem: [
                {
                    index: 1,
                    name: '项目立项',
                    status: 1
                },
                {
                    index: 2,
                    name: '编号申请',
                    status: 0
                },
                {
                    index: 3,
                    name: '盖章申请',
                    status: 0
                },
                {
                    index: 4,
                    name: '开票申请',
                    status: 0
                },
                // {
                //     index: 5,
                //     name: '结算申请',
                //     status: 0
                // },
                // {
                //     index: 6,
                //     name: '结果归档',
                //     status: 0
                // }
                {
                    index: 5,
                    name: '结果归档',
                    status: 0
                },
                {
                    index: 6,
                    name: '结算申请',
                    status: 0
                }
            ],
            showJsmx: false
        }
    },
    computed: {},
    watch: {},
    created() {
        this.getList()

        setTimeout(() => {
            this.showJsmx = true
        }, 500)
    },
    beforeDestroy() {},
    mounted() {
        this.attachments = this.vo.attachments
    },
    methods: {
        getList() {
            this.$http({
                method: 'GET',
                contentType: 'application/x-www-form-urlencoded',
                params: { id: this.$route.query.busiDataId },
                url: this.$route.query.wfEngineUrl + '/getProcessById'
            }).then(
                (response) => {
                    if (response.code === 'success') {
                        const tableData = response.body.listdata
                        var uniqueFlTypes = [...new Set(tableData.map((item) => item.flType))]
                        console.log(uniqueFlTypes, 'uniqueFlTypes')
                        uniqueFlTypes.forEach((item) => {
                            this.xmItem.forEach((item2) => {
                                if (item === '发布公告' && item2.name === '公告管理') {
                                    item2.status = 1
                                } else if (item === '结果公示' && item2.name === '结果公告') {
                                    item2.status = 1
                                } else if (item2.name === item) {
                                    item2.status = 1
                                }
                            })
                        })
                        let findItem = this.xmItem.find((item) => item.name === uniqueFlTypes[uniqueFlTypes.length - 1])
                        if (findItem) findItem.status = 2
                    } else {
                        this.$message.error(response.message)
                    }
                },
                (err) => {
                    console.log(err)
                }
            )
        }
    }
}
</script>

<style scoped lang="scss">
@import '~@/wapp/common/styles/variables.module.scss';

/deep/.el-form .el-table.el-table--border td {
    text-align: left;
}

.jdt {
    width: 100%;

    .jdt-main {
        display: flex;
        justify-content: space-around;
        text-align: center;
    }

    .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        width: 16.67%;
    }

    .item-top {
        width: 40px;
        height: 40px;
        background: #dee2e6;
        color: #fff;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 22px;
        position: relative;
    }

    .item::before {
        content: '';
        width: 50%;
        height: 2px;
        background-image: linear-gradient(to right, #dee2e6 70%, transparent 70%);
        background-size: 4px 1px;
        position: absolute;
        top: 18px;
        z-index: 1;
        right: calc(76% + 0px);
    }

    .item-top_item0ea04d::before {
        background: #4caf50;
        background-image: none !important;
    }

    .item:first-child::before {
        content: '';
        width: 0%;
        height: 2px;
        background-image: linear-gradient(to right, #dee2e6 70%, transparent 70%);
        background-size: 4px 1px;
        position: absolute;
        bottom: 38%;
        z-index: 1;
        right: -108px;
    }

    .item-text {
        font-size: 16px;
        padding: 13px;
    }
}
</style>
